class ProductUtilsService {
  isPromotion (product) {
    return product.promotedPrice && product.promotedPrice !== product.price
  }

  getActualPrice (product) {
    if (this.isPromotion(product)) {
      return product.promotedPrice
    }
    return product.price
  }

  isFree (product) {
    // First replace commas by dots
    const price = product.price.replace(/,/g, '.')
    // Check that the price equals 'free' or 0
    return product.price.match(/free/i) || parseFloat(price) === 0
  }

  isPromotedFree (product) {
    // First replace commas by dots
    const promotedPrice = product.promotedPrice.replace(/,/g, '.')
    // Check that the price equals 'free' or 0
    return this.product.isPromoted && (product.promotedPrice.match(/free/i) || parseFloat(promotedPrice) === 0)
  }

  getBanner (product) {
    if (product.isPromoted) {
      return 'catalog.product.banner.promoted'
    }
    if (product.isTop) {
      return 'catalog.product.banner.top'
    }
    return null
  }

  getIllustration (product) {
    const icon = product.icon || 'default'
    return `/${icon}.gif`
  }

  getDuration (product, selected) {
    if (!selected) {
      return 'catalog.product.duration.from'
    }
    if (product.duration) {
      if (product.duration === '1') {
        return 'catalog.product.duration.month'
      } else if (product.duration > 1) {
        return 'catalog.product.duration.months'
      }
    }
    return null
  }

  isPack (product) {
    return (product.productType === 'RcsPack')
  }

  isMus (product) {
    return (product.productType === 'RcsMus')
  }

  isPackOrBundle (product) {
    return (product.productType === 'RcsPack' || product.productType === 'RcsBundle')
  }

  isContent (product) {
    return (product.productType === 'RcsContent')
  }

  isProduct (product) {
    return (product.productType === 'RcsProduct')
  }

  isExpired (product) {
    if (product.expirationDate) {
      return new Date(product.expirationDate) < new Date()
    }
    return false
  }

  getButtonLabel (product) {
    let label
    if (!product.isSerial) {
      if (product.isPurchasable && product.isPurchased) {
        if ((this.isPack(product) || this.isMus(product)) && product.isRenewable) {
          if (this.isSubscriptionInProgress(product) || (this.isSubscriptionActive(product) && !this.isExpired(product))) {
            if ((product.isEligibilitySLKrequested && product.isEligibilitySLK) || !product.isEligibilitySLKrequested) {
              label = 'productDetails.extend'
            }
          } else {
            if ((product.isEligibilitySLKrequested && product.isEligibilitySLK) || !product.isEligibilitySLKrequested) {
              label = 'productDetails.renew'
            }
          }
        }
      } else {
        if (product.isTrialConsumed) {
          label = 'productDetails.extend'
        } else if (this.getTryAndBuy(product)) {
          label = 'productDetails.try'
        } else {
          label = 'productDetails.buy'
        }
      }
    }
    return label
  }

  getTryAndBuy (product) {
    return (product.isPurchasable && !product.isPurchased && (this.isPack(product) || this.isMus(product)) && parseInt(product.tryDuration) > 0)
  }

  getScreenShots (screenshotsArray) {
    const screensArrayFull = []
    screenshotsArray.forEach((screenshot) => {
      if (screenshot) screensArrayFull.push(screenshot)
    })
    if (screensArrayFull.length === 0) {
      screensArrayFull.push('screen/no-screenshot-available')
    }
    return screensArrayFull
  }

  getWarningMessage (product, totalSpaceWarning, huType) {
    let message = 'productDetails.warningMessage.'
    if (totalSpaceWarning === 'map' || totalSpaceWarning === 'mus') {
      message += 'insufficientTotalSpace.' + totalSpaceWarning + '.' + huType
    } else if (totalSpaceWarning === 'pds') {
      message += 'deviceUnknown'
    } else if (product.isSerial === true) {
      message += 'actionImpossible'
    } else {
      switch (product.infoCode) {
        case 0:
          message = null
          break
        case 1:
          message += 'missingConnectivity'
          break
        case 2:
          message += 'requiredApp'
          break
        case 7:
          message += 'insufficientSpace'
          break
        case 8:
          message += 'deviceUnknown'
          break
        case 9:
          if (product.productType === 'BUNDLE') {
            message += 'requiredSkuMissing.bundle'
          } else {
            message += 'requiredSkuMissing.pack'
          }
          break
        case 10:
          message += 'requiredSkuMissing.app'
          break
        default:
          message += 'default'
          break
      }
    }
    return message
  }

  getPackContent (product) {
    let packContent
    if (this.isPackOrBundle(product) && product.items) {
      packContent = product.items.item
    }
    return packContent
  }

  isBuyable (product, car, userOwnLastestVersion) {
    // console.debug('userOwnLastestVersion:' + JSON.stringify(userOwnLastestVersion))
    return product.infoCode !== 3 && product.infoCode !== 5 &&
      !this.getParentAppOrConnectivityRequired(product) &&
      !this.getIsDeviceUnknownForContent(product, car) &&
      (this.isMM14(car) || userOwnLastestVersion || !this.isNotEnoughSpaceForContent(product, car.huType))
  }

  isMM14 (car) {
    const isMM14 = car.huType && car.huType === 'RADNAV'
    // console.debug('isMM14:' + isMM14)
    return isMM14
  }

  getParentAppOrConnectivityRequired (product) {
    const resp = product.infoCode === 1 || product.infoCode === 2 || product.infoCode === 10
    // console.debug('getParentAppOrConnectivityRequired:' + resp)
    return resp
  }

  getIsDeviceUnknownForContent (product, car) {
    const resp = product && product.productType && this.isContent(product) && car.isConnected && product.infoCode === 8
    // console.debug('getIsDeviceUnknownForContent:' + resp)
    return resp
  }

  isNotEnoughSpaceForContent (product, huType) {
    var resp = false
    if (!(huType === 'MM12' && ((product.tomtomId && product.tomtomId.substring(0, 4) === 'map/') || product.packageNameMus))) {
      resp = product && product.productType && this.isContent(product) && product.infoCode === 7
    }
    // console.debug('isNotEnoughSpaceForContent:' + resp)
    return resp
  }

  isSubscriptionInProgress (product) {
    return (product.status === 'INPROGRESS')
  }

  isSubscriptionActive (product) {
    return (product.status === 'ACTIVE')
  }

 }

export default ProductUtilsService



// WEBPACK FOOTER //
// ./src/app/services/product/product-utils.service.js